import React, {memo} from 'react'

/* Components */
import HorizontalProductsSkeleton from '../../../../components/HorizontalProductsSkeleton/HorizontalProductsSkeleton'

/* Styles */
import s from './recomendation.scss'

const RecommendationSkeleton = memo(({platform}) => {
  const isMobile = platform === 'mobileweb'
  const cardCount = isMobile ? 3 : 6
  return <HorizontalProductsSkeleton cardCount={cardCount} cardClassName={s.placeholderCard} className={s.skeletonWrapper}/>
})

export default RecommendationSkeleton
